export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11301.2a42dfac.jpg";